'use strict';

import {fd, measure, mutate} from './promise-fastdom';
import mergeOpts from './merge-opts';
import ObserverList from './ObserverList';
import imageLoaded from './image-loaded';

export default function CanvasOverlay(node, options) {
	const self = this;
	this.node = node;
	this.observers = new ObserverList();

	this.canvas = document.createElement('canvas');
	this.canvas.classList.add('canvas-overlay');
	this.options = mergeOpts({
		insert: true,
		useDpr: false
	}, options);

	if (this.options.insert) {
		fd.mutate(() => {
			if (this.node.parentNode.tagName === 'PICTURE') {
				this.node.parentNode.parentNode.insertBefore(this.canvas, this.node.parentNode);
			} else {
				this.node.parentNode.insertBefore(this.canvas, this.node);
			}
		});
	}

	this.onResize = () => this.resize();
	window.addEventListener('resize', this.onResize);
	this.resize();

	// because of relayouts
	setTimeout(() => this.resize(), 500);

	if (node.tagName === 'IMG' && !imageLoaded.call(node)) {
		node.addEventListener('load', function loaded() {
			node.removeEventListener('load', loaded);
			self.resize();
		});
	}
}

CanvasOverlay.prototype.destroy = function () {
	window.removeEventListener('resize', this.onResize);
};

CanvasOverlay.prototype.addObserver = function (observer) {
	this.observers.add(observer);
};

CanvasOverlay.prototype.removeObserver = function (observer) {
	this.observers.remove(observer);
};

CanvasOverlay.prototype.notify = function (context) {
	this.observers.update(context);
};

CanvasOverlay.prototype.resize = function () {
	const data = {};
	return Promise.resolve()
		.then(measure(() => {
			const dpr = this.options.useDpr ? window.devicePixelRatio : 1;
			const rect = this.node.getBoundingClientRect();
			data.width = rect.width;
			data.height = rect.height;
			data.left = this.node.offsetLeft;
			data.top = this.node.offsetTop;
			data.realWidth = Math.round(data.width * dpr);
			data.realHeight = Math.round(data.height * dpr);

			const styles = window.getComputedStyle(this.node);
			data.fit = styles.objectFit;
		}))
		.then(mutate(() => {

			// internal size
			this.canvas.width = data.realWidth;
			this.canvas.height = data.realHeight;

			// element position
			if (this.options.insert) {
				this.canvas.style.position = 'absolute';
				this.canvas.style.left = data.left + 'px';
				this.canvas.style.top = data.top + 'px';
				this.canvas.style.width = data.width + 'px';
				this.canvas.style.height = data.height + 'px';
			}

			this.notify(data);
		}));
};
